import { observer } from "mobx-react-lite";

import { ImportApplicationModal } from "../../../components/import-application";
import { usePageStore } from "../applications-page.lib";

export const ApplicationsImportModal = observer(() => {
  const store = usePageStore()!;

  return (
    <ImportApplicationModal
      isOpen={store.popupAction?.type === "import-application"}
      onImported={() => store.refreshApplications()}
      onOpenChange={(open) => {
        if (!open) {
          store.setPopupAction(null);
        }
      }}
    />
  );
});
